var Newsletter = (function () {
    var newsletterCheckboxVisibleOnStep1 = false;

    return {
        setNewsletterCheckboxVisibleOnStep1: function(visible) {
             if (typeof visible !== 'boolean') {
                 console.error("Boolean value is required to set newsletter checkbox visibility on step 1");
                 return;
             }
            newsletterCheckboxVisibleOnStep1 = visible;
        },

        isNewsletterCheckboxVisibleOnStep1: function () {
            return newsletterCheckboxVisibleOnStep1;
        }
    };
} ());